
<div class="row">
    <div class="col-12">
        <img class="icon-close" (click)="onCloseClick()" src="assets/icons/ico-close.png" alt="close icon">
    </div>
</div>
<div class="row">
    <div class="col-12">
   <!-- <img class="icon-bloqueo" src="{{ data.icon }}" alt="icon">-->

    <h1 mat-dialog-title class="c-titulo-dialogo"> {{ data.title }} </h1>

    <ng-container *ngIf="data.deleteAction; else noEsEliminar">
        <mat-dialog-content class="c-titulo-subtitulo">{{ data.description }} <strong> {{ data.productTitle }}</strong> ? <br>{{ data.description2 }}</mat-dialog-content>
    </ng-container>

    <ng-template #noEsEliminar>
        <mat-dialog-content class="c-titulo-subtitulo" [innerHtml]="data.description"> </mat-dialog-content>
    </ng-template>

</div>
<div class="row auto">
    <mat-dialog-actions class=" col-sm-12 col-md-6 auto">
        <button (click)="onSecondaryActionClick()" class="btn-secondary-tbk mx-auto ">{{ data.cancelButton}}</button>

    </mat-dialog-actions>
    <mat-dialog-actions class="col-sm-12 col-md-6 dis auto">
    <button (click)="onActionClick()" class="btn-primary-tbk mx-auto  ">{{ data.actionButton }}</button>
</mat-dialog-actions>
</div>
</div>
